import { Button, FormHelperText, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { LTI_KEYSET_URL, LTI_OIDC_URL, LTI_REDIRECT_URI } from '../../../../../config/apiPaths';
import { getUrls } from '../../../../../utils/url';

interface UrlRowProps {
    label: string | null;
    url: string | undefined;
    showCopy?: boolean;
}

interface LTI13UrlsProps {
    ltiCredsUuid: string;
    selectedLMS: string;
}

const UrlRowDiv = styled.div`
    margin-top: 24px;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
`;

const UrlTextColumnDiv = styled.div`
    display: flex;
    flex-direction: column;
`;

const CopyButton = styled(Button)`
    margin-left: 12px;
`;

const UrlRow: React.FC<UrlRowProps> = ({ label, url, showCopy = true }) => {
    const { t } = useTranslation('admin_settings');

    const copyUrl = () => {
        navigator.clipboard.writeText(url || '');
    };

    return (
        <UrlRowDiv>
            <UrlTextColumnDiv>
                <Typography variant="body1">{label}</Typography>
                <FormHelperText>{url}</FormHelperText>
            </UrlTextColumnDiv>
            {showCopy && (
                <CopyButton variant="outlined" onClick={copyUrl}>
                    {t('copy')}
                </CopyButton>
            )}
        </UrlRowDiv>
    );
};

const LTI13Urls = (props: LTI13UrlsProps) => {
    const { ltiCredsUuid, selectedLMS } = props;
    const { t } = useTranslation('admin_settings');
    const { api } = getUrls();
    const selectedLMSLowercase = selectedLMS.toLowerCase();
    return (
        <>
            <UrlRow label={t(`class-oidc-endpoint.${selectedLMSLowercase}`)} url={`${api}${LTI_OIDC_URL}`} />
            <UrlRow label={t(`class-redirect-url.${selectedLMSLowercase}`)} url={`${api}${LTI_REDIRECT_URI}`} />
            <UrlRow
                label={t(`class-keyset-url.${selectedLMSLowercase}`)}
                url={`${api}${LTI_KEYSET_URL}?kid=${ltiCredsUuid}`}
            />
        </>
    );
};

export default LTI13Urls;
